import {cn} from '@/lib/utils';
import {getInitials} from '@/utils/getInitials';
import {getProfileName} from '@/utils/getProfileName';

type ProfileShape = {
  firstName: string | null;
  lastName: string | null;
  displayName: string | null;
  avatarUrl: string | null;
};

type Props = {
  profile: ProfileShape;
  size?: 'sm' | 'md';
  className?: string;
};

/**
 * Avatar circle for a profile. Renders the profile's avatarUrl when
 * present, otherwise a colored circle with the profile's initials.
 */
export function ProfileAvatar({profile, size = 'md', className}: Props) {
  const sizeClass = size === 'sm' ? 'w-9 h-9 text-xs' : 'w-10 h-10 text-sm';
  const name = getProfileName(profile);

  if (profile.avatarUrl) {
    return (
      <img
        src={profile.avatarUrl}
        alt={name}
        className={cn(sizeClass, 'rounded-full object-cover', className)}
      />
    );
  }

  return (
    <div
      className={cn(
        sizeClass,
        'rounded-full bg-secondary-500 text-white flex items-center justify-center font-semibold',
        className,
      )}
    >
      {getInitials(name)}
    </div>
  );
}
